import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './MultipleTabsAlert.module.scss';

function MultipleTabsAlert() {
  const { t } = useTranslation();
  const message = t('alert.manytab');

  return (
    <div className={classes.Wrapper}>
      <div className={classes.Message}>
        {message}
      </div>
    </div>
  );
}

export default MultipleTabsAlert;
